import React, { useMemo } from 'react';
import { useHtmlClassService } from '../../../_core/MetronicLayout';
import { useCustomTheme } from '../../../../../app/hooks/useCustomTheme';
import { AsideMenuList2 } from './AsideMenuList2';
import { useSelector } from 'react-redux';
import { USER_MODE } from '@/app/data/userModeConstants';

export function AsideMenu({ disableScroll }) {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes('aside_menu'),
      ulClasses: uiService.getClasses('aside_menu_nav', true),
      asideClassesFromConfig: uiService.getClasses('aside_menu', true)
    };
  }, [uiService]);

  const customTheme = useCustomTheme();
  const style = customTheme?.sidebar;

  const user = useSelector(state => state.auth.user);
  const isAdmin = user?.mode === USER_MODE.SHOP_ADMIN;
  const canShowMenu = !isAdmin || Boolean(user?.currentRole);

  return (
    <>
      {/* begin::Menu Container */}
      <div
        style={{ background: style.bgColor }}
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu my-4 `}
        // {...layoutProps.asideMenuAttr}
      >
        {canShowMenu && <AsideMenuList2 layoutProps={layoutProps} />}
      </div>
      {/* end::Menu Container */}
    </>
  );
}
